export default {
  contractMission: {
    contractMission: {
      title: ({ plural }) => plural(["Mission", "Missions"]),
      aiProposal: "AI proposal",
      activitiesLinked: ({ named }) => `${named("count")} linked activit${named("count") === 1 ? "y" : "ies"}`,
      levelOfAchievement: "Level of achievement",
      validate: "Validate this mission",
      decline: "Decline",
      merge: "Merge into...",
      defined: "Defined missions",
      no_missions: "No missions are defined on this contract.",
      import: "Import mission sheet",
      import_from_sheet: "Start adding some from a mission sheet",
      empty_no_sheet: "No missions are defined yet. Import a mission sheet to start tracking the apprentice.",
      empty_no_sheet_no_ia: "No missions are defined yet.",
      empty_no_sheet_cta: "Import a mission sheet",
      empty_has_sheet:
        "A mission sheet has been imported. Run the extraction to turn its content into missions to track.",
      empty_has_sheet_cta: "Run extraction",
      no_ia_alert: "Define and track the missions of your apprentice/intern in this tab",
      no_ia_alert_description: "Add a mission for your apprentice/intern",
    },
    rncpGlobalAnalysis: {
      button: "Global analysis",
      confirm_title: "Run the global analysis?",
      confirm_text:
        "This analysis gives an overview of the correlation between the missions and the targeted skills framework, to assess the apprentice's overall progress.",
      launch: "Run the analysis",
      loading_title: "Calculating the overall correlation with the skills framework",
      error_title: "The analysis could not be completed",
      failed: "The global analysis failed. Please run it again.",
      retry: "Run the analysis again",
      completed: "Analysis completed",
      step_reading_title: "Reading the missions",
      step_reading_subtitle: "All published missions of the contract and already validated links",
      step_matching_title: "Calculating the overall correlation",
      step_matching_subtitle: "Overall score and coverage by skills block",
      result_title: "Global analysis result",
      last_analysis: "Last analysis: {date}",
      missions_analysed: ({ plural, named }) =>
        plural([`${named("count")} mission analysed`, `${named("count")} missions analysed`]),
      score_label: "Overall correlation score",
      coverage_title: "Coverage by skills block",
      block_coverage_label: "{name}: {score}% coverage",
      result_empty: "No global analysis result yet.",
      rncp_title_unknown: "Framework not specified",
    },
    rncpMissionAnalysis: {
      button: "Mission analysis",
      confirm_title: "Run the mission analysis?",
      confirm_text:
        "This analysis helps understand and map the skills the apprentice develops through their missions: it suggests links with the skills framework, mission by mission, which you validate at your own pace.",
      launch: "Run the analysis",
      completed: "Analysis completed",
      loading_title: "Comparing missions with the skills framework",
      step_reading_title: "Reading missions",
      step_reading_subtitle: "Comments, achievement levels, objectives (questionnaire history)",
      step_matching_title: "Comparison with the framework",
      step_matching_subtitle: "Matching with the skill blocks",
      failed: "The mission analysis failed. Please run it again.",
      error_title: "The analysis could not be completed",
      retry: "Run the analysis again",
      result_title: "Mission analysis result",
      result_intro:
        "Analysing the relationship between missions and skills makes it easier to understand and map the skills the apprentice develops through their missions.",
      result_count: ({ plural, named }) => plural([`${named("count")} mission`, `${named("count")} missions`]),
      result_empty: "No missions to display for this analysis.",
      mission_status_to_validate: "To validate",
      mission_status_analysed: "Analysed",
      mission_status_none: "Not analysed",
      mission_no_content: "No validated skill or pending suggestion for this mission.",
      validated_title: "Validated skills",
      pending_title: "Pending AI suggestions",
      validate: "Validate",
      refuse: "Refuse",
      validate_label: ({ named }) => `Validate block ${named("name")}`,
      refuse_label: ({ named }) => `Refuse block ${named("name")}`,
      remove_label: ({ named }) => `Remove ${named("name")}`,
      score_value: ({ named }) => `Relevance score: ${named("score")}%`,
      show_detail: "Show details",
      hide_detail: "Hide details",
      show_detail_label: ({ named }) => `Show details of block ${named("name")}`,
      hide_detail_label: ({ named }) => `Hide details of block ${named("name")}`,
      detail_skills: "Skills of the block",
      suggestion_validated: ({ named }) => `Block ${named("name")} validated for the mission ${named("mission")}`,
      suggestion_refused: ({ named }) => `Suggestion ${named("name")} refused for the mission ${named("mission")}`,
      category_removed: ({ named }) => `Block ${named("name")} removed from the mission ${named("mission")}`,
      mission_skills_title: "Linked skill block",
      mission_skills_none: "No skill linked yet",
      mission_skills_add_placeholder: "+ Add a skill…",
      mission_skills_info: 'These actions are saved immediately, without using the mission\'s "Save" button.',
      mission_category_added: ({ named }) => `Block ${named("name")} added to the mission`,
      mission_category_validated: ({ named }) => `Block ${named("name")} validated`,
      mission_category_refused: ({ named }) => `Suggestion ${named("name")} refused`,
      mission_category_removed: ({ named }) => `Block ${named("name")} removed from the mission`,
    },
    import: {
      title: "Mission sheet splitting",
      intro: "AI identifies and reformulates missions from the sheet — you choose which ones to publish.",
      existing_sheet: "Mission sheet",
      upload_pdf: "Upload a PDF",
      free_text: "Or enter the content directly",
      free_text_placeholder: "Paste or type the content of your mission sheet…",
      or: "or",
      or_replace: "or upload another sheet",
      has_file_alert: "Sheet imported from the registration file",
      split_failed: "Automatic splitting failed. Please try running the splitting again.",
      launch: "Run extraction",
      loading_title: "Splitting in progress...",
      loading_subtitle: "AI is analysing and reformulating the missions",
      missions_proposed: "mission(s) proposed",
      validate_all: "Validate all",
      results_actions: "Actions on proposed missions",
      validate: "Validate",
      edit: "Edit",
      remove: "Remove",
      confirm_edit: "Confirm edit",
      field_name: "Mission name",
      field_description: "Mission description",
      no_missions: "No missions proposed.",
      publish: ({ named }) => `Publish ${named("count")} mission(s)`,
      publish_success: ({ named }) => `${named("count")} mission(s) published successfully`,
      removal_announcement: ({ named }) =>
        `Mission "${named("name")}" removed. ${named("count")} mission(s) proposed remaining.`,
    },
    banner: {
      title: "A mission sheet has been imported from the registration file",
      subtitle: "Split this sheet into missions to track the apprentice's progress throughout the apprenticeship",
      import: "Proceed with import",
      import_tooltip: "Open the mission sheet splitting modal",
      later: "Later",
      later_tooltip: "Hide this banner for this session",
    },
  },
};
